export default {"src":"https://wp-static.smartkarma.com/_next/static/media/revenue-alt-white.b647d7c1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};